// Copyright (c) 2020-2023 Visual Intelligence LP. All rights reserved.
// Note: Currently not in use.
//
import { observable, computed, action } from 'mobx';

import DependenciesService from '@shared/services/dependencies';
import Dependency, { DependencyDTO } from '@shared/models/dependency';
import { Id } from '@shared/types/common';
import { injectable } from 'inversify';
import BaseStore from '@core/stores/base';
import container from '@core/di';

@injectable()
export default class DependenciesStore extends BaseStore<DependencyDTO, Dependency, DependenciesService> {
  static diToken = Symbol('dependencies-store');

  // setup di token and clear the loading status.
  constructor() {
    super({ service: container.get<DependenciesService>(DependenciesService.diToken) });

    this.loading = {
      list: false,
      item: false,
    };
  }

  // Get a list of all dependecies by calling the service object.
  @action getDependencies = async (): Promise<Array<Dependency>> => {
    this.loading.list = true; // set loading status for the role.

    try {
      const deps = await this.service.getDependencies();
      this.loading.list = false;  // clear loading status.

      return deps;
    } 
    catch(err) {
      this.loading.list = false;  // clear loading status.

      throw err;
    }
  }

  // Get a dependecy by calling the service object.
  // Params:
  //   depQuery: id and type of the item to get.
  @action getDependency = async (depQuery: Partial<DependencyDTO>): Promise<Dependency | undefined> => {
    this.loading.item = true; // set loading status for the role.

    try {
      const dep = await this.service.getDependency(depQuery);
      this.loading.item = false;  // clear loading status.

      return dep;
    } 
    catch(err) {
      this.loading.item = false;  // clear loading status.

      throw err
    }
  }

}